<template>
  <div class="checkbox-container" :class="{ 'mb-8': !dense }">
    <fieldset class="rounded" />
    <v-checkbox
      class="mt-0"
      :class="!dense ? 'pa-4' : 'pa-2'"
      hide-details="auto"
      v-model="input"
      :rules="requiredRule"
      :disabled="disabled"
      :loading="loading"
      :hint="customField.hint"
      :label="customField.label"
      :error="error"
      persistent-hint
      @focus="onFocus"
      @blur="onBlur"
      @keydown.tab="onTab"
      @keydown.native="onKeydown"
    >
      <template v-slot:message="{ message }">
        <span v-html="message"></span>
      </template>
    </v-checkbox>
    <v-progress-linear v-if="loading" indeterminate :height="1" />
  </div>
</template>

<style scoped>
.checkbox-container {
  min-height: 32px;
  position: relative;
}

.checkbox-container fieldset {
  color: rgba(0, 0, 0, 0.38);
  border-collapse: collapse;
  border-color: currentColor;
  border-style: solid;
  border-width: 1px;
  bottom: 0;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition-duration: 0.15s;
  transition-property: color;
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
}
</style>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import CustomFieldText from "./CustomFieldText.vue";

@Component({
  components: {}
})
export default class CustomFieldBoolean extends CustomFieldText {
  @Prop()
  dense!: boolean;

  @Prop({ default: false })
  error!: boolean;

  get input() {
    return this.value === "true" || this.value === "false" ? JSON.parse(this.value) : this.value;
  }

  set input(v: string) {
    this.$emit("input", v);
  }

  onFocus(event: FocusEvent) {
    this.$emit("focus", event);
  }

  onBlur(event: FocusEvent) {
    this.$emit("blur", event);
  }

  onTab(event: FocusEvent) {
    this.$emit("keydown.tab", event);
  }

  onKeydown(event: KeyboardEvent) {
    this.$emit("keydown", event);
  }
}
</script>
